import { isInRange as i } from "@project-rouge/rg-core";
function r(t, f) {
  return !!(i(t[0], ...f) || i(t[1], ...f) || i(f[0], ...t) || i(f[1], ...t));
}
export {
  r as rangesOverlap
};
//# sourceMappingURL=index26.js.map
